/* RYDEON theme JS — dependency-free, loaded with defer. */
document.documentElement.classList.add('js');

(function () {
  'use strict';

  var CFG = window.RYDEON || {};
  var STR = CFG.strings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function drawerEnabled() {
    return !!drawer && CFG.cartType !== 'page' && !/^\/cart\/?$/.test(location.pathname);
  }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
    $$('[data-cart-toggle]').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
    setCartCount(Number(fresh.getAttribute('data-item-count') || 0));
  }

  function refreshDrawer() {
    return fetch(location.pathname + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); })
      .catch(function () {});
  }

  function openDrawer() {
    if (!drawerEnabled()) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = $('.cart-drawer__panel', drawer);
      if (panel) panel.focus({ preventScroll: true });
    });
    return true;
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || STR.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function afterCartUpdate(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      renderDrawer(data.sections['cart-drawer']);
    }
    if (!openDrawer()) {
      window.location.href = CFG.cartUrl;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Global click handling                                               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawerEnabled()) {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn && drawer && drawer.contains(qtyBtn)) {
      e.preventDefault();
      drawer.classList.add('is-loading');
      cartRequest(CFG.cartChangeUrl, {
        id: qtyBtn.getAttribute('data-line-key'),
        quantity: Number(qtyBtn.getAttribute('data-qty-change')),
        sections: 'cart-drawer'
      }).then(function (data) {
        renderDrawer(data.sections && data.sections['cart-drawer']);
      }).catch(function () {
        refreshDrawer();
      }).then(function () {
        drawer.classList.remove('is-loading');
      });
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty-input]');
      var input = wrap && $('input', wrap);
      if (input) {
        var min = input.hasAttribute('min') ? Number(input.min) : 1;
        var next = Math.max(min, (Number(input.value) || 0) + Number(step.getAttribute('data-qty-step')));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      var panel = $('[data-facets-panel]');
      if (panel && !panel.hidden) toggleFacets(false);
      var menu = $('[data-mobile-menu][open]');
      if (menu) menu.removeAttribute('open');
    }
    if (e.key === 'Tab' && drawer && !drawer.hidden && drawer.classList.contains('is-open')) {
      var focusables = $$('a[href],button:not([disabled]),input,select,[tabindex="0"]', drawer).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------------ */
  /* AJAX add to cart (product page, cards, drawer upsell)               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    if (!form.querySelector('[name="id"]')) return;
    e.preventDefault();

    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var root = form.closest('[data-product-section]') || form;
    var buttons = $$('[name="add"]', form).concat($$('[data-sticky-btn]', root));
    var labelEl = submitter && (submitter.querySelector('[data-atc-label],[data-sticky-label]') || submitter);
    var original = labelEl ? labelEl.textContent : '';
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;

    buttons.forEach(function (b) { b.classList.add('is-loading'); });
    if (labelEl) labelEl.textContent = STR.adding || 'Adding…';

    var fd = new FormData(form);
    fd.set('sections', 'cart-drawer');
    fd.set('sections_url', location.pathname);

    fetch(CFG.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || STR.error);
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        if (labelEl) labelEl.textContent = STR.added || 'Added';
        afterCartUpdate(data);
        setTimeout(function () { if (labelEl) labelEl.textContent = original; }, 1500);
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = original;
        if (errorEl) { errorEl.textContent = err.message || STR.error; errorEl.hidden = false; }
        else { window.alert(err.message || STR.error); }
      })
      .then(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); });
      });
  });

  /* ------------------------------------------------------------------ */
  /* Cart page: auto-update quantities                                   */
  /* ------------------------------------------------------------------ */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var updateBtn = $('[data-cart-update]', cartForm);
    var submitUpdate = debounce(function () {
      if (cartForm.requestSubmit && updateBtn) cartForm.requestSubmit(updateBtn);
      else if (updateBtn) updateBtn.click();
    }, 600);
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) submitUpdate();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Product page                                                        */
  /* ------------------------------------------------------------------ */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = $('.product-form', section);
    var idInput = form && $('[data-variant-id]', form);
    var groups = form ? $$('[data-option-index]', form) : [];
    var atc = $('[data-atc]', section);
    var atcLabel = $('[data-atc-label]', section);
    var stickyBtn = $('[data-sticky-btn]', section);
    var stickyLabel = $('[data-sticky-label]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var priceEl = $('[data-price]', section);
    var compareEl = $('[data-compare]', section);
    var badgeEl = $('[data-save-badge]', section);
    var stockEl = $('[data-stock-msg]', section);

    function selectedOptions() {
      return groups.map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setLabel(text, disabled) {
      if (atcLabel) atcLabel.textContent = text;
      if (stickyLabel) stickyLabel.textContent = text;
      [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = !!disabled; });
    }

    var ready = false;
    function update() {
      var opts = selectedOptions();

      groups.forEach(function (g, gi) {
        var sel = $('[data-option-selected]', g);
        var checked = $('input:checked', g);
        if (sel && checked) sel.textContent = checked.value;
        $$('input', g).forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var vv = findVariant(test);
          input.classList.toggle('is-unavailable', !vv || !vv.available);
        });
      });

      var v = groups.length ? findVariant(opts) : data.variants[0];
      if (!v) { setLabel(STR.unavailable || 'Unavailable', true); return; }

      if (idInput && String(idInput.value) !== String(v.id)) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) {
        priceEl.textContent = v.price;
        priceEl.classList.toggle('is-sale', !!v.compare);
      }
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (badgeEl) { badgeEl.textContent = 'Save ' + v.pct + '%'; badgeEl.hidden = !v.compare; }
      if (stickyPrice) stickyPrice.textContent = v.price;

      if (stockEl) {
        var low = data.lowStock > 0 && v.inventory !== null && v.inventory > 0 && v.inventory <= data.lowStock;
        stockEl.hidden = !low;
        if (low) stockEl.textContent = (STR.onlyLeft || 'Only [count] left in stock').replace('[count]', v.inventory);
      }

      setLabel(v.available ? (STR.addToCart || 'Add to cart') : (STR.soldOut || 'Sold out'), !v.available);

      if (ready && groups.length && window.history && history.replaceState) {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (ready && v.media) showMedia(v.media);
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('.option-input')) update();
      });
    }

    /* ---- Gallery ---- */
    var gallery = $('[data-gallery]', section);
    var track = gallery && $('[data-gallery-track]', gallery);
    var slides = track ? $$('.gallery__slide', track) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var dots = gallery ? $$('.gallery__dot', gallery) : [];
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      if (thumbs[i] && thumbs[i].scrollIntoView) {
        var holder = thumbs[i].closest('.gallery__thumbs');
        if (holder) holder.scrollTo({ left: thumbs[i].offsetLeft - 20, behavior: 'smooth' });
      }
    }
    function go(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    function showMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { go(i); return; }
      }
    }
    if (track) {
      var onScroll = debounce(function () {
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      }, 60);
      track.addEventListener('scroll', onScroll, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(Number(t.getAttribute('data-thumb'))); });
      });
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
    }

    /* ---- Lightbox zoom ---- */
    var box = $('[data-lightbox]', section);
    if (box && typeof box.showModal === 'function') {
      var boxImg = $('[data-lightbox-img]', box);
      var stage = $('[data-lightbox-stage]', box);
      gallery.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom-src]');
        if (!z) return;
        boxImg.src = z.getAttribute('data-zoom-src');
        boxImg.alt = z.getAttribute('data-zoom-alt') || '';
        stage.classList.remove('is-zoomed');
        box.showModal();
      });
      stage.addEventListener('click', function () { stage.classList.toggle('is-zoomed'); });
      $('[data-lightbox-close]', box).addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    }

    /* ---- Sticky add-to-cart ---- */
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
      }, { threshold: 0 });
      io.observe(atc);
    }

    update();
    ready = true;
  }

  $$('[data-product-section]').forEach(initProduct);

  /* ------------------------------------------------------------------ */
  /* Recommendations (related / frequently bought together)              */
  /* ------------------------------------------------------------------ */
  function loadRecs(section) {
    var url = section.getAttribute('data-recs-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recs-content]', doc);
        var target = $('[data-recs-content]', section);
        if (fresh && target && fresh.children.length) {
          target.innerHTML = fresh.innerHTML;
          section.classList.add('has-content');
        }
      })
      .catch(function () {});
  }
  var recSections = $$('[data-recs-section]');
  if (recSections.length) {
    if ('IntersectionObserver' in window) {
      var recIO = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { obs.unobserve(en.target); loadRecs(en.target); }
        });
      }, { rootMargin: '600px 0px' });
      recSections.forEach(function (s) { recIO.observe(s); });
    } else {
      recSections.forEach(loadRecs);
    }
  }

  /* Bundle (frequently bought together) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-bundle]');
    if (!form) return;
    e.preventDefault();
    var items = [];
    var mainId = $('[data-product-section] [data-variant-id]');
    var mainQty = $('[data-product-section] input[name="quantity"]');
    if (mainId) items.push({ id: Number(mainId.value), quantity: Number(mainQty && mainQty.value) || 1 });
    $$('[data-bundle-item]:checked', form).forEach(function (c) {
      items.push({ id: Number(c.getAttribute('data-variant-id')), quantity: 1 });
    });
    var btn = $('[data-bundle-submit]', form);
    var err = $('[data-bundle-error]', form);
    var label = btn.textContent;
    err.hidden = true;
    btn.classList.add('is-loading');
    btn.textContent = STR.adding || 'Adding…';
    cartRequest(CFG.cartAddUrl + '.js', { items: items, sections: 'cart-drawer', sections_url: location.pathname })
      .then(afterCartUpdate)
      .catch(function (ex) { err.textContent = ex.message || STR.error; err.hidden = false; })
      .then(function () { btn.classList.remove('is-loading'); btn.textContent = label; });
  });

  /* ------------------------------------------------------------------ */
  /* Collection filters & sorting                                        */
  /* ------------------------------------------------------------------ */
  var facetsForm = $('[data-facets-form]');
  var facetsPanel = $('[data-facets-panel]');

  function toggleFacets(open) {
    if (!facetsPanel) return;
    var overlay = $('.facets__overlay', facetsForm);
    var show = typeof open === 'boolean' ? open : facetsPanel.hidden;
    facetsPanel.hidden = !show;
    if (overlay) overlay.hidden = !show;
    $$('[data-facets-toggle]').forEach(function (b) {
      if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', show ? 'true' : 'false');
    });
    document.body.style.overflow = show ? 'hidden' : '';
  }

  if (facetsForm) {
    facetsForm.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-toggle]')) toggleFacets();
    });
    facetsForm.addEventListener('submit', function () {
      $$('input[type="number"]', facetsForm).forEach(function (i) { if (!i.value) i.disabled = true; });
    });
    var sort = $('[data-facets-sort]', facetsForm);
    if (sort) sort.addEventListener('change', function () { facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit(); });
    // Filters apply with the "Show results" button so shoppers can pick several first.
  }
})();
